module.exports = __webpack_public_path__ + "img/gift4-01-c08-k2.0551f52d.png";